/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Status_DeletedInputs */

const en_admin_payments_status_deleted = /** @type {(inputs: Admin_Payments_Status_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

const zh_admin_payments_status_deleted = /** @type {(inputs: Admin_Payments_Status_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已删除`)
};

/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {Admin_Payments_Status_DeletedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_status_deleted = /** @type {((inputs?: Admin_Payments_Status_DeletedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Status_DeletedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_status_deleted(inputs)
	return zh_admin_payments_status_deleted(inputs)
});
export { admin_payments_status_deleted as "admin.payments.status_deleted" }